import {lazy} from "react"

export const CustomerSupports = lazy(() => import("@/views/customerSupports/CustomerSupports"))
export const CustomerSupportsModal = lazy(() => import("@/views/customerSupports/components/CustomerSupportsModal"))